<template>
    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label class="label">Stock Dis.</label>
        </div>
        <div class="field-body">
            <div class="field">
                <div class="control has-icons-left">
                    <input class="input" v-model="stock_discount" type="text" placeholder="Stock discount" :class="{ 'is-danger': errors.stock_discount }">
                    <span class="icon is-left">
                       <i class="fas fa-tag"></i>
                    </span>
                    <p v-if="errors.stock_discount" class="help is-danger">{{ errors.stock_discount[0] }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {

            }
        },
        computed: {
            stock_discount: {
                get() {
                    return this.$store.getters.getNewPricePlan.stock_discount
                },
                set(value) {
                    this.$store.dispatch('setNewPricePlanFieldValue', {field: 'stock_discount', value: value})
                }
            },
            errors() {
                return this.$store.getters.getNewPricePlanErrors
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/PricePlans/NewPlan/Inputs/StockDiscountFee.vue